export const SET_PRODUCTS_LIST = (state, products) => {
  state.products = products;
  window.localStorage.setItem('products', JSON.stringify(state.products));
};

export const SET_SECTORS_LIST = (state, sectors) => {
  state.sectors = sectors;
  window.localStorage.setItem('sectors', JSON.stringify(state.sectors));
};

export const SET_CART_PRODUCTS = (state, products) => {
  state.cartProducts = products;
};

export const SET_SELECTED_SECTOR = (state, selectedSector) => {
  state.selectedSector = selectedSector;
};

export const SET_SEPARATE_PRODUCTS = (state, value) => {
  state.separateProducts = value;
};

export const SET_CUPOM_MESSAGE = (state, cupomMessage) => {
  state.cupomMessage = cupomMessage;
};

export const SET_SPECIAL_CUPOM = (state, isSpecialCupom) => {
  state.isSpecialCupom = isSpecialCupom;
};

export const SET_CUPOM_CARD = (state, isCupomCard) => {
  state.isCupomCard = isCupomCard;
};

export const SET_ALL_PRODUCTS = (state, productsNoGroup) => {
  state.productsNoGroup = productsNoGroup;
};

export const SET_EVENT_MAX_PER_CART_COUPON = (state, value) => {
  state.maxCartCoupon = value;
};

export const SET_TEMP_SELECTED_SECTOR = (state, tempSelectedSector) => {
  state.tempSelectedSector = tempSelectedSector;
};

export const SET_SECTOR_MAP = (state, sectorMap) => {
  state.sectorMap = sectorMap;
};

export const ADD_CART_PRODUCT = (state, product) => {
  if (state.selectedSector && product.haveSeat) {
    let record = false;
    if (!record)
      record = state.selectedSector.products.find(
        v =>
          `${v.codigo_produto}-${v.codigo_tipo}` ===
          `${product.codigo_produto}-${product.codigo_tipo}`
      );

    if (record && record.codigo_assento) {
      if (!record.seats) record.seats = [];
      if (!record.codes) record.codes = [];
      record.seats.push(record.codigo_assento);
      record.codes.push(record.codigo_obj);
      record.quantidade++;
    } else {
      product.quantidade = 1;

      const idx = state.selectedSector.products
        .map((v, i) => {
          if (v[i].codigo_produto === product.codigo_produto) {
            return i;
          }
        })
        .filter(v => v >= 0);
      state.selectedSector.products[idx].push(product);
    }
  } else {
    let record = false;
    state.noSectorProducts.forEach(p => {
      if (!record)
        record = p.find(
          v =>
            `${v.codigo_produto}-${v.codigo_tipo}` ===
            `${product.codigo_produto}-${product.codigo_tipo}`
        );
    });
    if (record) {
      record.quantidade++;
    } else {
      product.quantidade = 1;

      const idx = state.noSectorProducts
        .map((v, i) => {
          if (v[i] && v[i].codigo_produto === product.codigo_produto) {
            return i;
          }
        })
        .filter(v => v >= 0);

      if (
        state.noSectorProducts &&
        state.noSectorProducts.length &&
        state.noSectorProducts[idx[0]]
      )
        state.noSectorProducts[idx[0]].push(product);
    }
  }
};

export const REMOVE_CART_PRODUCT = (state, product) => {
  if (state.selectedSector && product.haveSeat) {
    let record = false;
    if (!record)
      record = state.selectedSector.products.find(
        v =>
          `${v.codigo_produto}-${v.codigo_tipo}` ===
          `${product.codigo_produto}-${product.codigo_tipo}`
      );
    if (record) {
      record.seats.splice(record.seats.indexOf(record.codigo_assento), 1);
      record.codes.splice(record.codes.indexOf(record.codigo_obj), 1);
      record.seat_id.splice(record.seat_id.indexOf(record.identificacao), 1);
      record.quantidade--;
    }
  } else {
    let record = false;
    state.noSectorProducts.forEach(p => {
      if (!record)
        record = p.find(
          v =>
            `${v.codigo_produto}-${v.codigo_tipo}` ===
            `${product.codigo_produto}-${product.codigo_tipo}`
        );
    });
    if (record) {
      record.quantidade--;
    }
  }
};

export const SET_CUPOM_CODE = (state, cupomCode) => {
  state.cupomCode = cupomCode;
};

export const SET_IS_VALID_CUPOM_CODE = (state, isValidCupomCode) => {
  state.isValidCupomCode = isValidCupomCode;
};

export const SET_IS_CUPOM_TRACKING = (state, isCupomTracking) => {
  state.isCupomTracking = isCupomTracking;
};

export const SET_SALE_UNINITIATED = (state, value) => {
  state.saleUninitiated = value;
};

export const SET_SELECTED_INFO = (state, selectedInfo) => {
  state.selectedInfo = selectedInfo;
};
export const SET_HAS_CUPOM = (state, hasCupom) => {
  state.hasCupom = hasCupom;
};

export const SET_NOSECTOR_LIST = (state, noSectorProducts) => {
  state.noSectorProducts = noSectorProducts;
};

export const SET_CUPOM_DATA = (state, cupomData) => {
  state.cupomData = cupomData;
};

export const SET_PRODUCTS_ALL = (state, productsAll) => {
  state.productsAll = productsAll;
};

export const SET_SHOW_QUEUE = (state, showQueue) => {
  if (!showQueue) state.passedQueue = true;
  state.showQueue = showQueue;
};

export const SET_MESSAGE_QUEUE = (state, messageQueue) => {
  state.messageQueue = messageQueue;
};

export const SET_POSITION = (state, positionQueue) => {
  state.positionQueue = positionQueue;
};

export const SET_TICKET_CODE_URL = (state, value) => {
  state.ticketCodeUrl = value;
};

export const SET_PRODUCTS_CODE_URL = (state, value) => {
  state.productsCodeUrl = value;
};
